import { useEffect, useRef } from "react";

// Pointer-based signature pad; exports a PNG blob through onChange (null when empty).
export const SignaturePad = ({ onChange, clearLabel, hint }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const dirty = useRef(false);

  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio; c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio); ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#002068";
  }, []);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture(e.pointerId); drawing.current = true; const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.moveTo(...pos(e)); };
  const move = (e) => { if (!drawing.current) return; const ctx = ref.current.getContext("2d"); ctx.lineTo(...pos(e)); ctx.stroke(); dirty.current = true; };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (dirty.current) ref.current.toBlob((b) => onChange(b), "image/png");
  };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); dirty.current = false; onChange(null); };

  return (
    <div>
      <div className="relative">
        <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} data-testid="signature-pad"
          className="h-40 w-full touch-none rounded-xl border-2 border-dashed border-slate-300 bg-white" />
        <span className="pointer-events-none absolute bottom-2 left-3 text-xs text-slate-300">{hint}</span>
      </div>
      <button type="button" onClick={clear} className="mt-1 h-9 text-xs font-medium text-slate-500 hover:text-navy" data-testid="signature-clear">{clearLabel}</button>
    </div>
  );
};
